const V = {
  name: "SanFrancisco",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 21V16H17V21H19V16H24V14H19V8.89617C20.2711 10.194 22.0425 11 24 11V9C21.2423 9 19 6.75772 19 4V3H17V4C17 6.75772 14.7577 9 12 9C9.24228 9 7 6.75772 7 4V3H5V4C5 6.75772 2.75772 9 0 9V11C1.95751 11 3.7289 10.194 5 8.89617V14H0V16H5V21H7ZM7 8.89617C8.2711 10.194 10.0425 11 12 11C13.9575 11 15.7289 10.194 17 8.89617V14H7V8.89617Z" fill="currentColor"/>
</svg>
  `
};
export {
  V as SanFrancisco
};
